import $ from 'jquery';
export default (function() {
    /* eslint-disable no-unused-vars */
      var loading = document.querySelector('.js-load-more');
      var selectTimeout;
      var appendToGrid = false;
      var nextPage = 2;
      function updateNextPage(currentPage) {
        nextPage = currentPage + 1;
      }
      function debounceUpdateGrid(appendToGrid, nextPage) {
        clearTimeout(selectTimeout);
        //ajax call
        selectTimeout = setTimeout(function () {
          updateGrid(appendToGrid, nextPage);
        }, 1500);
      }
      function updateGrid(appendToGrid, nextPage) {
        //defaults - reset
        var page = 1;
        //use pagination if we're appending
        if (appendToGrid) {
          page = nextPage;
        } else {
          $('.article-container').addClass('loading');
        }

        // Get current URL parameters for filters
        const urlParams = new URLSearchParams(window.location.search);
        const topic = urlParams.get('topic');

        var postData = {
          'page': page,
          'renderMarkup': true,
          'exclude_ids': window.featuredPostIds || [],
        };

        // Add any active filters to the request
        if (topic) {
          postData.category_name = topic;
        }

        $.ajax({
            url: '/wp-json/lp/v1/posts',
            type: 'GET',
            data: postData,
          })
          .done(function (data, textStatus, jqXHR) {
            console.log('HTTP Request Succeeded: ' + jqXHR.status);
            console.log(data);
            if (appendToGrid) {
              console.log('appending to grid');
              $('.article-container').last().append(data.data.markup);
              updateNextPage(data.data.current_page);
            } else {
              console.log('swapping out grid');
              $('.article-container').last().html(data.data.markup);
              updateNextPage(data.data.current_page);
            }
            $('.article-container').removeClass('loading');
            console.log(data.data.markup);
            var url = '/blog/';
            var state = {};
            const title = 'Blog Page';

            // Preserve filter parameters in URL
            if (topic) {
              url += (url.includes('?') ? '&' : '?') + 'topic=' + topic;
            }

            // Add page number
            url += (url.includes('?') ? '&' : '?') + 'paged=' + page;

            //push it
            history.pushState(state, title, url);
            loading.innerHTML = 'More posts'
          })
          .fail(function (jqXHR, textStatus, errorThrown) {
            console.log('HTTP Request Failed');
          })
          .always(function () {
            /* ... */
          });
      }
      function init() {
        if(loading){
         loading.addEventListener('click', function(e){
            e.preventDefault();
            loading.innerHTML = 'Loading...'
              //append
            appendToGrid = true;
            debounceUpdateGrid(appendToGrid, nextPage)
              //reset
            appendToGrid = false;
          });
        }
      };
      /* eslint-enable no-unused-vars */
  return {
    init: init,
  }
  /* eslint-enable no-unused-vars */
})();
